import React from "react";
import { observer } from "mobx-react";
import { WeaInput } from "ecCom";

@observer
export default class AdSearchInputItem extends React.PureComponent {
  onEnterSearch = value => {
    const { itemKey, onEnterSearch } = this.props;
    if (typeof onEnterSearch === "function") {
      onEnterSearch(itemKey, value);
    }
  };
  render() {
    const { bindObj } = this.props;
    return (
      <WeaInput
        {...bindObj.bind()}
        ecId={`${this.props.ecId}_WeaInput@qhpo68`}
        onEnterSearch={this.onEnterSearch}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/AdSearchInputtem.js